/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import LayoutModel from 'cio/models/layout';
import TemplateModel from 'cio/models/template';
import { BeeTemplate } from 'cio/data/bee-templates';

interface Args {
  previewing: TemplateModel | BeeTemplate | LayoutModel;
  isSelecting: boolean;
  onSelect: () => void;
  closePreview: () => void;
}

export default class ActionComposerTypesEmailChooseTemplatePreviewModal extends Component<Args> {
  @tracked isLoaded = false;

  @action
  didLoadPreview() {
    this.isLoaded = true;
  }

  get name() {
    let { previewing } = this.args;

    if (previewing instanceof BeeTemplate || previewing instanceof LayoutModel) {
      return previewing.name;
    }

    if (previewing.action) {
      return previewing.action.name;
    } else if (previewing.newsletter) {
      return previewing.newsletter.name;
    } else if (previewing.transactionalMessage) {
      return previewing.transactionalMessage.name;
    }

    return;
  }

  get body() {
    let { previewing } = this.args;

    if (previewing instanceof TemplateModel && previewing.transactionalMessage) {
      return previewing.transactionalMessage.preview;
    } else {
      return previewing.body;
    }
  }

  get isBeeTemplate() {
    return this.args.previewing instanceof BeeTemplate;
  }

  get isLayout() {
    return this.args.previewing instanceof LayoutModel;
  }
}
